import { ANYONE_ID } from 'Calendar/anyone';
import { loadingPageSignal } from 'components/LoadingPage';
import moment from 'moment';
import QuickBookContext from 'QuickBooking/Context';
import qbSignal from 'QuickBooking/signal';
import apis from 'services/apis';
import { ICustomerUI } from 'types/customer';
import { getSystemMomentFormat } from 'utils/time';
import toast from 'utils/toast';

const useCallerId = () => {
  const book = async (callerId: string, _customer?: ICustomerUI | undefined) => {
    const result = await QuickBookContext.caller(callerId, _customer);
    if (!result) return;
    const { customer, staff, timeSlot } = result;
    qbSignal.open(staff?.id || '', getSystemMomentFormat(timeSlot) || '', { customer, callerId, requestStaff: staff?.id === ANYONE_ID ? false : true });
  };

  const sms = async (id: string, customer?: ICustomerUI | undefined) => {
    if (!customer) return;
    loadingPageSignal.value = true;
    try {
      const res: any = await apis.sendSmsBookingOnline(id, customer.phone);
      if (res.data.payload) {
        toast.success('Send SMS successfully');
      }
    } catch (error) {
    } finally {
      loadingPageSignal.value = false;
    }
  };

  return ({ book, sms });
};

export default useCallerId;
